/**
 * RecipeVideo
 *
 * Used in the RecipeVideo block and recipe_video.blade.php template. Will make
 * an AJAX call to the backend through the Varnish tunnel and provide the video
 * that is to be embedded based on the user's country.
 *
 * @author Tim
 */
export default class RecipeVideo {
    constructor($iframe) {
        this.$iframe = $iframe;

        this.updateUrl = this.updateUrl.bind(this);
        this.fetchUrl = this.fetchUrl.bind(this);

        this.updateUrl();
    }

    async updateUrl() {
        const result = await this.fetchUrl();

        if (result.href) {
            this.$iframe.src = result.href;
        }
    }

    async fetchUrl() {
        try {
            let url =  placeholders.baseUri ?
                placeholders.baseUri + '/ajax-data/recipe-video' :
                '/ajax-data/recipe-video';

            url += '?id=' + this.$iframe.dataset.recipeId;

            const request = await fetch(
                url,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                }
            );

            return await request.json();
        } catch (e) {
            console.log(e);
        }
    }
}
